<script setup>

import {computed} from "vue";

const props = defineProps({
    hoursSaved: {
        type: Number,
        required: true,
    }
})

const message = computed(() => {
    const hoursSavedFlooredToNearestFive = Math.floor(props.hoursSaved / 5) * 5;
    if (hoursSavedFlooredToNearestFive === 0 || hoursSavedFlooredToNearestFive > 100) {
        return null
    }

    let oneToFiveRandom = Math.floor(Math.random() * 5) + 1;
    return 'timeSaved:'+hoursSavedFlooredToNearestFive+'.'+oneToFiveRandom;
})

</script>

<template>
    <div v-if="message">{{ _mft(message) }} </div>
</template>

<style scoped>

</style>
